var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "calendar-settings" } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c(
            "SupsisButton",
            {
              staticClass: "create-reservation",
              on: {
                click: function ($event) {
                  return _vm.goReservationPage()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calendar.createAppoint")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "integretion",
              style: !!_vm.userOAtuh
                ? "backgroundColor: #5c5c5c"
                : "backgroundColor: #ec4b1d",
              attrs: { "aria-disabled": _vm.btnEnabled },
              on: { click: _vm.googleCalendarIntegration },
            },
            [
              _c("div", [
                _vm._v(
                  _vm._s(
                    !!_vm.userOAtuh
                      ? _vm.$t("calendar.googleDisconnect")
                      : _vm.$t("calendar.googleConnect")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("open_in_new"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("span", { staticStyle: { display: "flex" } }, [
                _vm._v(_vm._s(_vm.$t("fastWizard.customHoursTimezone"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: {
                    "show-search": "",
                    placeholder: "Select Timezone",
                    "option-filter-prop": "children",
                  },
                  on: { change: _vm.changeTimezone },
                  model: {
                    value: _vm.settings.timezone,
                    callback: function ($$v) {
                      _vm.$set(_vm.settings, "timezone", $$v)
                    },
                    expression: "settings.timezone",
                  },
                },
                _vm._l(_vm.timezones, function (tz, i) {
                  return _c(
                    "a-select-option",
                    { key: i, attrs: { value: tz } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(tz) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("VisibilityChanger", {
            staticStyle: { "margin-top": "10px" },
            attrs: { "show-title": false, alertMessage: false },
            model: {
              value: _vm.visibilityData,
              callback: function ($$v) {
                _vm.visibilityData = $$v
              },
              expression: "visibilityData",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }